import SocialCampaignTypeToken from '@apps/campaigns/admin/tokens/social_campaign_type'
import MJSONScreenshot from '@admin/components/mjson_screenshot'
import Image from '@admin/components/image'
import Date from '@admin/components/date'
import PropTypes from 'prop-types'
import React from 'react'

const getScreenshot = (entity) => ({
  engine: 'mjson',
  entity: `campaigns_social_campaign_variants/${entity.code}`,
  width: 100,
  height: 75,
  screenshoted_at: entity.screenshoted_at
})

const getThumbnailImage = (variant) => {
  // If we have a thumbnail asset (keyframe or image), use it
  if(variant.thumbnail) {
    const isVideo = variant.thumbnail.content_type && variant.thumbnail.content_type.startsWith('video/')
    const src = isVideo ? variant.thumbnail.preview : variant.thumbnail.path
    
    return {
      src,
      transforms: { fit: 'cover', w: 300, h: 300 },
      title: 'Thumbnail'
    }
  }
  
  // If no thumbnail but we have a video, use its preview.jpg
  if(variant.video) {
    return {
      src: variant.video.preview,
      transforms: { fit: 'cover', w: 300, h: 300 },
      title: 'Video Preview'
    }
  }
  
  // No thumbnail available
  return { src: null }
}

const getPreview = (variant, mode) => {
  const thumbnail = getThumbnailImage(variant)
  if(thumbnail.src) {
    if(mode === 'grid') return <Image { ...thumbnail } />
    return <Image { ...{ ...thumbnail, transforms: { fit: 'cover', w: 200, h: 150 } } } />
  }
  return <MJSONScreenshot { ...getScreenshot(variant) } />
}

const SocialCampaignToken = ({ social_campaign, mode }) => {
  const variant = social_campaign.variants?.[0]
  return (
    <div className="campaign-token">
      <div className="campaign-token-preview">
        <div className="campaign-token-preview-inner">
          { variant && getPreview(variant, mode) }
        </div>
      </div>
    <div className="campaign-token-label">
      <div className="token-link">
        { social_campaign.title }
      </div>
      <SocialCampaignTypeToken social_campaign={ social_campaign } />
      <div className="token-stats">
        <span className={ social_campaign.status }>{ social_campaign.status }</span>
        { social_campaign.status === 'scheduled' &&
          <span><Date datetime={ social_campaign.post_at } /></span>
        }
        { social_campaign.status === 'posted' &&
          <span><Date datetime={ social_campaign.posted_at } /></span>
        }
      </div>
    </div>
  </div>
  )
}

SocialCampaignToken.propTypes = {
  social_campaign: PropTypes.object,
  mode: PropTypes.string
}

export default SocialCampaignToken
